export class Details {
  id: number;
  itemKey: string;
  title: string;
  content: string;
  redirectUrl: string;
}
